import { render } from "./AddAttributeValue.vue?vue&type=template&id=07d25a93&ts=true"
import script from "./AddAttributeValue.vue?vue&type=script&lang=ts"
export * from "./AddAttributeValue.vue?vue&type=script&lang=ts"

import "./AddAttributeValue.vue?vue&type=style&index=0&id=07d25a93&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__